<quant-modal [responsiveStyles]="true">
  <div class="modal">
    <div class="header">
      <qai-loading
        *ngIf="isRestoring"
        [size]="'small'"
        class="theme-light"
      ></qai-loading>
        
      <img
        *ngIf="control?.callThumbnail && !isRestoring"
        qai-image
        class="thumbnail"
        [objectFit]="'contain'"
        [src]="control?.callThumbnail"
        [alt]="'Avatar of the call'"
      />

      <div class="title">
        {{
          isRestoring
            ? ('call.RESTORE_CALL' | transloco)
            : ('call.PAUSED_SIMULATION' | transloco)
        }}
      </div>

      <div class="message">
        {{
          isRestoring
            ? ('call.FEW_SECONDS' | transloco)
            : ('call.PAUSED_SIMULATION_DESCRIPTION' | transloco)
        }}
      </div>
    </div>
    <div class="actions">
      <button
        qai-button
        size="large"
        [kind]="'tertiary'"
        [disabled]="isRestoring"
        (click)="handleViewSettingsClick()"
      >
        <qai-icon kind="settings" positionStart />
        {{'call.SETTINGS' | transloco}}
      </button>
      <button
        qai-button
        size="large"
        [kind]="'primary'"
        [disabled]="isRestoring"
        (click)="handleResumeClick()"
      >
        <qai-icon kind="play-circle" positionStart />
        {{'call.RESUME' | transloco}}
      </button>
    </div>
  </div>
</quant-modal>